import usePost from '../api/usePost';
import { useState } from 'react';

function MultiShipmentForm({notify, visible, setVisible, selectedOrders, setSelectedOrders, setFormSubmitted, formSubmitted}) {
  const { postData, isLoading, error } = usePost();
  const [formData, setFormData] = useState({order_ids: selectedOrders, tracking_number: '', cost: '', currency: 'EUR'});
  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
      console.log(formData)
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      const response = await postData('/create_purchase_multi_shipment', formData);
      if (response) {
        setFormSubmitted(!formSubmitted);
        setVisible(false);
        setTimeout(() => {
          setSelectedOrders([]);
        }, 0);
        notify('Shipment Saved')
      }
    };
    const handleClose = () => {
        setVisible(false);
      };
  return (
    visible && (<div id="multi-shipment-form">
    <i id="close-shipment-form" className="fas fa-times" onClick={handleClose}></i>
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="tracking-number">Tracking Number:</label>
        <input type="text" id="tracking-number" name="tracking_number" value={formData.tracking_number} onChange={handleChange}/>
        <br />
        <label htmlFor="cost">Cost:</label>
        <input type="text" id="cost" name="cost" value={formData.cost} onChange={handleChange}/>
        <br />
        <select id="currency" name="currency" value={formData.currency} onChange={handleChange}>
          <option value="USD">USD</option>
          <option value="EUR">EUR</option>
          <option value="JPY">JPY</option>
          <option value="GBP">GBP</option>
          <option value="AUD">AUD</option>
        </select>
        <button type="submit">
          <i className="fas fa-save" disabled={isLoading}></i>Save
        </button>
      </div>
    </form>
    {error && <p>Error: {error}</p>}
  </div>)
  )
}

export default MultiShipmentForm